import keyMirror from "keymirror";

const ActionTypes = {
  STATISTICS_RECEIVED: "STATISTICS_RECEIVED",
  STATISTICS_SYNC: "STATISTICS_SYNC",
};

export default ActionTypes;
